import React from 'react';
import { Container } from 'reactstrap';

import config from '../../../../config.js';

// Attente du chunk /cart : pas de marge haute et au moins la hauteur de l'écran, pour que
// le panier prenne la place de ce bloc sans pousser le contenu ni le footer.
function CartRouteFallback() {
    return (
        <Container fluid className="page-wrapper checkout-lux" style={{ minHeight: '100vh' }} aria-busy="true">
            <div className="text-center pt-5">
                <img src={`${config.staticUrl}assets/images/ellipsis.svg`} height="20" alt="" />
            </div>
        </Container>
    );
}

export default CartRouteFallback;
